import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const INVOICE_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<Invoice>[] = [
    { name: "total", label: "Total" },
    { name: "date_issued", label: "Issued" },
    { name: "terms", label: "Terms" },
    { name: "payment_status", label: "Paid Status" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const INVOICE_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<Invoice>[] = [
    { name: "id", label: "ID" },
    { name: "client_name", label: "Client" },
    { name: "status_label", label: "Status" },
    { name: "amount_due", label: "Amt. Due" },
    { name: "total", label: "Total" },
    { name: "service_name", label: "Service" },
    { name: "service_location_name", label: "Location Name" },
    { name: "service_location_address", label: "Location Address" },
    { name: "date_issued", label: "Issued" },
    { name: "date_due", label: "Due Date" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "last_viewed", label: "Seen" },
    { name: "last_sent_at", label: "Sent" },
    { name: "last_paid_at", label: "Paid" },
    { name: "last_voided_at", label: "Voided" },
    { name: "last_forgiven_at", label: "Forgiven" },
]
